"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.save = exports.remove = exports.purge = exports.load = exports.SessionStorage = exports.LocalStorage = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _cookies = require("./cookies");
exports.Cookie = _cookies.Cookie;
exports.necessary = _cookies.necessary;
exports.analytics = _cookies.analytics;
exports.marketing = _cookies.marketing;
exports.LocalStorage = _cookies.LocalStorage;
exports.SessionStorage = _cookies.SessionStorage;
const load = key => {
  var _cookie$get;
  return (_cookie$get = _jsCookie.default.get(key)) !== null && _cookie$get !== void 0 ? _cookie$get : null;
};
exports.load = load;
const save = function (key, value, opts) {
  if (opts === void 0) {
    opts = {};
  }
  const name = (0, _cookies.getCanonicalName)(key);
  if (name == null) {
    return;
  }
  const options = (0, _cookies.getOptions)(name, opts);
  if (name in _cookies.necessary) {
    // For now the /set API endpoint only accepts AGREED and SETTINGS
    // and no options are passed.
    if (key === _cookies.Cookie.AGREED || key === _cookies.Cookie.SETTINGS) {
      fetch(`/api/cookies/set/?cookie=${key}&value=${value}`).then(res => {
        if (!res.ok) {
          _jsCookie.default.set(key, value, options);
        }
      }).catch(() => {
        _jsCookie.default.set(key, value, options);
      });
      return;
    }
    _jsCookie.default.set(key, value, options);
    return;
  }
  const rawSettings = load(_cookies.Cookie.SETTINGS);
  if (rawSettings === null) {
    return;
  }
  const settings = JSON.parse(rawSettings);
  if ((0, _cookies.shouldSetCookie)(name, settings)) {
    _jsCookie.default.set(key, value, options);
  }
};
exports.save = save;
const remove = function (key, opts) {
  if (opts === void 0) {
    opts = {};
  }
  _jsCookie.default.remove(key, opts);
  // the default domain for many 3rd party services:
  _jsCookie.default.remove(key, {
    ...opts,
    domain: ".kiwi.com"
  });
};
exports.remove = remove;
const purge = function (settings, cookie) {
  if (cookie === void 0) {
    cookie = document.cookie;
  }
  const cookies = cookie.split("; ").map(pair => pair.split("=")[0]);
  const categories = [settings.analytics ? null : "analytics", settings.marketing ? null : "marketing"].filter(c => c != null);
  if (categories.length > 0) {
    /**
     * This request performs a side-effect through the set-cookie headers
     * it receives in the response.
     */
    fetch(`/api/cookies/remove/?categories=${categories.join(",")}`).catch(() => {});
  }

  /**
   * In the future, we could consider adding a check to verify that the
   * set-cookie headers we're expecting were received, and run the
   * JSCookie based logic only in case we did not get all the expected
   * set-cookie headers or the API call failed.
   */
  cookies.forEach(key => {
    const name = (0, _cookies.getCanonicalName)(key);
    if (name == null) {
      // When full list of cookies will be in code, uncomment this to only
      // allow known cookies to exist:
      // // Removes unknown cookies
      // remove(key);
      return;
    }
    if (!settings.analytics && name in _cookies.analytics) {
      remove(key);
      return;
    }
    if (!settings.marketing && name in _cookies.marketing) {
      remove(key);
    }
  });
};
exports.purge = purge;